import { DateTime } from 'luxon';
import type { LeagueProjectionAttributes } from '@library/types/leagues';
import type { StringKeyNumberValue } from '@bo-types/common';

type CalculatedBoardStartTimes = { boardTime: string; startTime: string };

export const leagueStartTimeAdditionalMins: StringKeyNumberValue = {
  CBB2H: 90,
  CFB2H: 110,
  CFB4Q: 150,
  MLBLIVE_NON_FIRST: 110,
  NBA2H: 110,
  NBA4Q: 150,
  NFL2H: 110,
  NFL4Q: 150,
  NHL2P: 60,
  NHL3P: 120,
  SOCCER2H: 60,
  WNBA2H: 110,
  WNBA4Q: 150
};

export const leagueBoardTimeAdditionalMins: StringKeyNumberValue = {
  CFB4Q: 110,
  MLBLIVE: 30,
  NBA4Q: 110,
  NFL4Q: 110,
  TENNISLIVE: 30
};

export const getCalculatedBoardStartTimes = ({
  durations,
  durationId,
  gameStartTime,
  leagueName
}: {
  durations: LeagueProjectionAttributes[];
  durationId: string;
  gameStartTime: string | undefined;
  leagueName: string;
}): CalculatedBoardStartTimes => {
  if (!gameStartTime) {
    return { boardTime: '', startTime: '' };
  }

  const gameStartDateTime = DateTime.fromISO(gameStartTime);
  const additionalBoardTimeMins = leagueBoardTimeAdditionalMins[leagueName];
  const additionalStartTimeMins = leagueStartTimeAdditionalMins[leagueName];

  if (leagueName === 'MLBLIVE') {
    const duration = durations.find(
      (leagueDuaration) =>
        leagueDuaration.leagueProjectionFilterId === durationId
    );

    const isFirstInnings =
      duration && duration.leagueProjectionFilterName.includes('1');

    const mlbLiveStartTime = !isFirstInnings
      ? gameStartDateTime
          .plus({ minutes: leagueStartTimeAdditionalMins.MLBLIVE_NON_FIRST })
          .toISO() || ''
      : gameStartTime;

    return {
      boardTime:
        isFirstInnings && additionalBoardTimeMins
          ? gameStartDateTime
              .plus({ minutes: additionalBoardTimeMins })
              .toISO() || ''
          : mlbLiveStartTime,
      startTime: mlbLiveStartTime
    };
  }

  const startTime = additionalStartTimeMins
    ? gameStartDateTime.plus({ minutes: additionalStartTimeMins }).toISO() || ''
    : gameStartTime;

  const boardTime = additionalBoardTimeMins
    ? gameStartDateTime.plus({ minutes: additionalBoardTimeMins }).toISO() || ''
    : startTime;

  return { boardTime, startTime };
};
